export default "__VITE_ASSET__B7yj1kZR__"